import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=e791cd66&scoped=true"
import script from "./Roles.vue?vue&type=script&setup=true&lang=ts"
export * from "./Roles.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e791cd66",
  null
  
)

export default component.exports